import { IEquipment } from '@/pages/Equipment/equipment.types'
import equipmentUtils from '@/pages/Equipment/equipment.utils'
import { IOption } from '@/types/global'

const fieldTypeOptions: IOption<IEquipment['state']>[] = [
  { title: equipmentUtils.getStateText('RUNNING'), value: 'RUNNING' },
  { title: equipmentUtils.getStateText('ERROR'), value: 'ERROR' },
  { title: equipmentUtils.getStateText('DISCONNECTED'), value: 'DISCONNECTED' },
  { title: equipmentUtils.getStateText('STOPPED'), value: 'STOPPED' },
]

const equipmentFilterStatusConstants = { fieldTypeOptions }
export default equipmentFilterStatusConstants
